/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { ProtocolInterface } from "../../interfaces/Protocols.interface";
// CONSTANTS
import { BLANK_PROTOCOL } from "../../constants/protocol";
import { FormAction } from "../../types/enums";

/**
 * State of the protocol slice: the protocol currently being viewed or edited,
 * the active selection, and the open/closed flags for this area's modals.
 */
export interface ProtocolState {
  protocol: ProtocolInterface;
  openDrawer: boolean;
  openForm: boolean;
  refreshTable: boolean;
  formAction: FormAction;
  openModalDelete: boolean;
}

const initialState: ProtocolState = {
  protocol: { ...BLANK_PROTOCOL },
  openDrawer: false,
  openForm: false,
  refreshTable: false,
  formAction: FormAction.Create,
  openModalDelete: false,
};

export const protocolSlice = createSlice({
  name: "protocol",
  initialState,
  reducers: {
    updateProtocol: (state, action: PayloadAction<ProtocolInterface>) => {
      state.protocol = action.payload;
    },
    updateOpenDrawer: (state, action: PayloadAction<boolean>) => {
      state.openDrawer = action.payload;
    },
    updateOpenForm: (state, action: PayloadAction<boolean>) => {
      state.openForm = action.payload;
    },
    updateRefreshTable: (state, action: PayloadAction<boolean>) => {
      state.refreshTable = action.payload;
    },
    updateFormAction: (state, action: PayloadAction<FormAction>) => {
      state.formAction = action.payload;
    },
    updateOpenModalDelete: (state, action: PayloadAction<boolean>) => {
      state.openModalDelete = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateProtocol,
  updateOpenDrawer,
  updateOpenForm,
  updateRefreshTable,
  updateFormAction,
  updateOpenModalDelete,
} = protocolSlice.actions;

export default protocolSlice.reducer;
